export default [
    {
        path: "/xhs/kol/dashboard/view",
        name: "xhs-kol-dashboard",
        component: () => import("@/views/kol/dashboard/view.vue"),
    },
    {
        path: "/xhs/kol/account/diagnosis",
        name: "xhs-kol-account-diagnosis",
        component: () => import("@/views/kol/account/diagnosis.vue"),
    },
    {
        path: "/xhs/kol/account/analysis",
        name: "xhs-kol-account-analysis",
        component: () => import("@/views/kol/account/analysis.vue"),
    },
    {
        path: "/xhs/kol/account/position",
        name: "xhs-kol-account-position",
        component: () => import("@/views/kol/account/position.vue"),
    },

    {
        path: "/xhs/kol/strategy/matrix",
        name: "xhs-kol-strategy-matrix",
        component: () => import("@/views/kol/strategy/matrix.vue"),
    },
    {
        path: "/xhs/kol/strategy/icebreaker",
        name: "xhs-kol-strategy-icebreaker",
        component: () => import("@/views/kol/strategy/icebreaker.vue"),
    },
    {
        path: "/xhs/kol/strategy/calendar",
        name: "xhs-kol-strategy-calendar",
        component: () => import("@/views/kol/strategy/calendar.vue"),
    },
    {
        path: "/xhs/kol/strategy/simulator",
        name: "xhs-kol-strategy-simulator",
        component: () => import("@/views/kol/strategy/simulator.vue"),
    },

    {
        path: "/xhs/kol/inspiration/trend",
        name: "xhs-kol-inspiration-trend",
        component: () => import("@/views/kol/inspiration/trend.vue"),
    },
    {
        path: "/xhs/kol/inspiration/template",
        name: "xhs-kol-inspiration-template",
        component: () => import("@/views/kol/inspiration/template.vue"),
    },
    {
        path: "/xhs/kol/inspiration/keyword",
        name: "xhs-kol-inspiration-keyword",
        component: () => import("@/views/kol/inspiration/keyword.vue"),
    },
    {
        path: "/xhs/kol/inspiration/audience",
        name: "xhs-kol-inspiration-audience",
        component: () => import("@/views/kol/inspiration/audience.vue"),
    },

    {
        path: "/xhs/kol/toolbox/rewrite",
        name: "xhs-kol-toolbox-rewrite",
        component: () => import("@/views/kol/toolbox/rewrite.vue"),
    },
    {
        path: "/xhs/kol/toolbox/keyword",
        name: "xhs-kol-toolbox-keyword",
        component: () => import("@/views/kol/toolbox/keyword.vue"),
    },
    {
        path: "/xhs/kol/toolbox/image",
        name: "xhs-kol-toolbox-image",
        component: () => import("@/views/kol/toolbox/image.vue"),
    },
    {
        path: "/xhs/kol/toolbox/video",
        name: "xhs-kol-toolbox-video",
        component: () => import("@/views/kol/toolbox/video.vue"),
    },
    {
        path: "/xhs/kol/toolbox/dy",
        name: "xhs-kol-toolbox-dy",
        component: () => import("@/views/kol/toolbox/dy.vue"),
    },
    {
        path: "/xhs/kol/toolbox/check",
        name: "xhs-kol-toolbox-check",
        component: () => import("@/views/kol/toolbox/check.vue"),
    },
    {
        path: "/xhs/kol/toolbox/cover",
        name: "xhs-kol-toolbox-cover",
        component: () => import("@/views/kol/toolbox/cover.vue"),
    },
    {
        path: "/xhs/kol/toolbox/headline",
        name: "xhs-kol-toolbox-headline",
        component: () => import("@/views/kol/toolbox/headline.vue"),
    },
    {
        path: "/xhs/kol/toolbox/brand",
        name: "xhs-kol-toolbox-brand",
        component: () => import("@/views/kol/toolbox/brand.vue"),
    },

    {
        path: "/xhs/kol/operation/grow",
        name: "xhs-kol-operation-grow",
        component: () => import("@/views/kol/operation/grow.vue"),
    },
    {
        path: "/xhs/kol/operation/review",
        name: "xhs-kol-operation-review",
        component: () => import("@/views/kol/operation/review.vue"),
    },
    {
        path: "/xhs/kol/operation/engagement",
        name: "xhs-kol-operation-engagement",
        component: () => import("@/views/kol/operation/engagement.vue"),
    },
    {
        path: "/xhs/kol/operation/comment",
        name: "xhs-kol-operation-comment",
        component: () => import("@/views/kol/operation/comment.vue"),
    },
    {
        path: "/xhs/kol/operation/traffic",
        name: "xhs-kol-operation-traffic",
        component: () => import("@/views/kol/operation/traffic.vue"),
    },
    {
        path: "/xhs/kol/operation/fan",
        name: "xhs-kol-operation-fan",
        component: () => import("@/views/kol/operation/fan.vue"),
    },

    {
        path: "/xhs/kol/asset/visual",
        name: "xhs-kol-asset-visual",
        component: () => import("@/views/kol/asset/visual.vue"),
    },
    {
        path: "/xhs/kol/asset/inspiration",
        name: "xhs-kol-asset-inspiration",
        component: () => import("@/views/kol/asset/inspiration.vue"),
    },
    {
        path: "/xhs/kol/asset/draft",
        name: "xhs-kol-asset-draft",
        component: () => import("@/views/kol/asset/draft.vue"),
    },

    {
        path: "/xhs/kol/monetization/opportunity",
        name: "xhs-kol-monetization-opportunity",
        component: () => import("@/views/kol/monetization/opportunity.vue"),
    },
    {
        path: "/xhs/kol/monetization/brief",
        name: "xhs-kol-monetization-brief",
        component: () => import("@/views/kol/monetization/brief.vue"),
    },
    {
        path: "/xhs/kol/monetization/coop",
        name: "xhs-kol-monetization-coop",
        component: () => import("@/views/kol/monetization/coop.vue"),
    },
]